import RequireModule from 'routes/components/RequireModule';

import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import ChartRedirect from './ChartRedirect';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const Payments = withLazyFallback(() => import('components/practice/charts/Payments/Payments'));
const PaymentMethods = withLazyFallback(
  () => import('components/practice/charts/Payments/components/PaymentMethods/PaymentMethods')
);
const PatientInvoices = withLazyFallback(
  () => import('components/practice/charts/billing/Invoices/PatientInvoices')
);
const Transactions = withLazyFallback(
  () => import('components/practice/charts/billing/transactions/Transactions')
);
const PatientPlans = withLazyFallback(
  () => import('components/practice/charts/billing/Plans/PatientPlans')
);
const PatientAutoRecurring = withLazyFallback(
  () => import('components/practice/charts/billing/Plans/components/PatientAutoRecurring')
);
const PatientInstallments = withLazyFallback(
  () => import('components/practice/charts/billing/Plans/components/PatientInstallments')
);
const PurchasedPackages = withLazyFallback(
  () => import('components/practice/charts/Account/tabs/PurchasedPackages/PurchasedPackages')
);
const Quotes = withLazyFallback(
  () => import('components/practice/charts/Account/tabs/Quotes/Quotes')
);
const CConFile = withLazyFallback(
  () => import('components/practice/charts/Account/tabs/CConFile/CConFileTable')
);
const AchOnFile = withLazyFallback(
  () => import('components/practice/charts/Account/tabs/AchOnFile/AchOnFile')
);

const PRACTICE_CHARTS_PAYMENTS = [
  {
    path: 'payments',
    element: <Payments />,
    handle: { title: 'Invoices & payments' },
    children: [
      { path: 'invoices', element: <PatientInvoices />, handle: { title: 'Invoices' } },
      {
        path: 'payments',
        element: <Transactions />,
        handle: { title: 'Payments' },
        children: [{ path: ':transactionId' }]
      },
      {
        path: 'plans',
        element: (
          <RequireModule module="medipay.payment_suite.recurring_charges">
            <PatientPlans />
          </RequireModule>
        ),
        handle: { title: 'Payment plans' },
        children: [
          { path: 'auto-recurring', element: <PatientAutoRecurring /> },
          { path: 'installments', element: <PatientInstallments /> }
        ]
      },
      {
        path: 'transactions/*',
        element: <ChartRedirect to="payments/payments" />
      },
      { path: 'packages', element: <PurchasedPackages />, handle: { title: 'Packages' } },
      { path: 'quotes', element: <Quotes />, handle: { title: 'Quotes' } },
      {
        path: 'methods',
        element: <PaymentMethods />,
        handle: { title: 'Payment methods' },
        children: [
          { path: 'cards', element: <CConFile /> },
          { path: 'bank-accounts', element: <AchOnFile /> }
        ]
      },
      {
        path: 'methods/ach',
        element: <ChartRedirect to="payments/methods/bank-accounts" keepRest={false} />
      },
      { path: '*', element: <NotFound /> }
    ]
  },
  { path: 'account', element: <ChartRedirect to="payments/packages" /> },
  { path: 'account/purchased-packages', element: <ChartRedirect to="payments/packages" /> },
  { path: 'account/quotes', element: <ChartRedirect to="payments/quotes" /> },
  { path: 'account/cards', element: <ChartRedirect to="payments/methods/cards" /> },
  { path: 'account/ach', element: <ChartRedirect to="payments/methods/bank-accounts" /> },
  { path: 'account/settings', element: <ChartRedirect to="profile/contact-info" /> },
  { path: 'account/*', element: <ChartRedirect to="payments" keepRest={false} /> },
  { path: 'settings', element: <ChartRedirect to="profile/contact-info" /> }
];

export default PRACTICE_CHARTS_PAYMENTS;
